const GAME_EVENT_FORM_BROADCAST_FIELDS = {
  IS_BROADCAST: 'isBroadcast',
  IS_RECORD: 'isRecord',
  AUTO_START: 'autoStart',
  AUTO_STOP: 'autoStop',
  IS_COMMENTARY_ON: 'isCommentaryOn',
  COMMENTARY_MODE: 'commentaryMode',
  TYPE: 'type',
  STREAM_DESTINATION: 'streamDestination',
  THIRD_PARTY_BROADCAST_URL: 'thirdPartyBroadcastUrl',
  IS_ADDITIONAL_STREAM_DESTINATION_ADDED: 'isAdditionalStreamDestinationAdded',
  STREAM_DESTINATION_2: 'streamDestination2',
  EVENT_YT_CONFIG: 'eventYTConfig',
  YOUTUBE_THUMBNAIL: 'thumbnail',
  BROADCAST_TITLE: 'broadcastTitle',
  YOUTUBE_VISIBILITY: 'visibility',
  TEAM_HOME: 'homeTeam',
  TEAM_AWAY: 'awayTeam',
  HOME_TEAM_INDEX: 'homeTeamIndex',
  TEAM_HOME_LOGO: 'homeTeamLogoDataUri',
  TEAM_AWAY_LOGO: 'awayTeamLogoDataUri',
  COURT_COMPETITION_NAME: 'competitionName',
  COURT_COMPETITION_LOGO: 'competitionLogoDataUri',
  COURT_TOP_LEFT_LOGO: 'courtTopLeftLogoDataUri',
  COURT_TOP_RIGHT_LOGO: 'courtTopRightLogoDataUri',
  COURT_BOTTOM_LEFT_LOGO: 'courtBottomLeftLogoDataUri',
  COURT_BOTTOM_RIGHT_LOGO: 'courtBottomRightLogoDataUri',
  COURT_CENTER_LOGO: 'courtCenterLogoDataUri',
  LOAD_RECENT_SETUPS: 'loadRecentSetups',
  IS_LIVESTREAM_TYPE_FULL: 'isLivestreamTypeFull',
  IS_LIVESTREAM_TYPE_LITE: 'isLivestreamTypeLite',
  UPLOADED_MEDIAS: 'uploadedMedias',
  GAME_STATE_TRACKING_AUTO: 'gameStateTrackingAuto',
  GAME_STATE_TRACKING_MANUAL: 'gameStateTrackingManual',
  STATISTICIAN_IDS: 'statisticianIds',
  SHARED_REVENUE: 'sharedRevenue',
  SCOREBOARD_SOURCE: 'scoreboardSource',
}

export default GAME_EVENT_FORM_BROADCAST_FIELDS
